import React, { ReactNode } from 'react'
import { Layout } from 'components/Layout'
import { Footer } from 'components/Footer'
import { CheckoutLayoutRoot, Wrapper, CardContainer, BackButton } from './CheckoutLayout.styles'
import { Header } from 'components/Header'
import { Stack } from 'components/Stack'
import { Icon } from 'components/Icon'
import { useTranslation } from 'hooks/useTranslation'
import { FC } from 'react'
import { Link } from 'components/Link'
import { useRouter } from '../../../hooks/useRouter'

type CheckoutLayoutProps = {
  hideCTA?: boolean
  hideBackgroundPatterns?: boolean
  returnUrl: string
  children?: ReactNode
}

export const CheckoutLayout: FC<CheckoutLayoutProps> = ({
  children,
  hideCTA = false,
  hideBackgroundPatterns = false,
  returnUrl,
  ...rest
}) => {
  const { pathname } = useRouter()
  let trimmed = false
  if (pathname.includes('/meal-plan/checkout')) trimmed = true
  const header = <Header trimmed={trimmed} />
  const { t } = useTranslation()

  return (
    <CheckoutLayoutRoot {...rest}>
      <Layout
        header={header}
        CTA={{ text: 'meal-plan:product-page.check-out' as const, url: '/meal-plan/checkout' }}
        hideCTA={hideCTA}
      >
        <Wrapper hideBackgroundPatterns={hideBackgroundPatterns}>
          <Stack direction="column" justifyContent="center" gap="2">
            <Link href={returnUrl} passHref>
              <BackButton>
                <Icon name="angle-left" />
                {t('common:back')}
              </BackButton>
            </Link>
            <CardContainer>{children}</CardContainer>
          </Stack>
        </Wrapper>
        <Footer />
      </Layout>
    </CheckoutLayoutRoot>
  )
}

CheckoutLayout.displayName = 'CheckoutLayout'
